// src/components/Inlay.tsx
import React from "react";
import { ArrowLeftIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { A } from "../styles/appleClasses";

type Props = {
  title: string;
  backLabel?: string;
  closeLabel?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  onClose: () => void;
  /** Optional: custom back handler; defaults to onClose */
  onBack?: () => void;
  /** Optional: hide back arrow (defaults to true = show) */
  showBack?: boolean;
};

export default function Inlay({
  title,
  backLabel = "Back",
  closeLabel = "Close",
  children,
  footer,
  onClose,
  onBack,
  showBack = true,
}: Props) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-2"
      role="dialog"
      aria-modal="true"
    >
      <div className={`w-full max-w-lg px-5 py-5 sm:px-6 sm:py-6 ${A.modal} shadow-md`}>
        {/* Standard header: back ← | Title (center) | × close */}
        <div className="relative flex items-center justify-center h-10 pb-3 mb-4 border-b border-gray-200">
          {showBack ? (
            <button
              type="button"
              className={`${A.iconBtn} absolute left-0 top-1/2 -translate-y-1/2 inline-flex items-center justify-center
                hover:bg-gray-100 transition
                focus:outline-none focus:ring-2 focus:ring-appleblueD`}
              onClick={onBack ?? onClose}
              aria-label={backLabel}
            >
              <ArrowLeftIcon className="w-5 h-5 text-gray-500" />
            </button>
          ) : (
            <span className="absolute left-0" />
          )}

          <div className={`${A.title} text-center`}>{title}</div>

          <button
            type="button"
            onClick={onClose}
            className={`${A.iconBtn} absolute right-0 top-1/2 -translate-y-1/2 inline-flex items-center justify-center
              hover:bg-gray-100 transition
              focus:outline-none focus:ring-2 focus:ring-appleblueD`}
            aria-label={closeLabel}
          >
            <XMarkIcon className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div>{children}</div>

        {footer && (
          <div className="mt-5 pt-4 border-t border-gray-200 flex justify-end gap-2">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
